import {Service} from "@/services/superclasses/service";
import {Article} from "@/interfaces/article";
import {FpArticle} from "@/interfaces/fp-article";

const api = window.contextPath + '/rest/articles';

export class ArticleService extends Service {

    constructor() {
        super()
    }

    public loadByVatin = async (args: {
        vatin: string,
        first?: number,
        max?: number
    }): Promise<Article[]> => {
        return this.data(await this.get<Article[]>(api + "/by-vatin",
            {
                params: args
            }))
    }

    public loadFpRecommended = async (articleId: number, max?: number): Promise<FpArticle[]> => {
        return this.data(await this.get<FpArticle[]>(api + "/" + articleId + "/fp-recommended",
            {
                params: {
                    max
                }
            }))
    }

    public loadBreaking = async (): Promise<Article[]> => {
        return this.data(await this.get<Article[]>(api + "/breaking"))
    }

    public loadByTopic = async (topicId: number, first?: number, max?: number): Promise<FpArticle[]> => {
        return this.data(await this.get<FpArticle[]>(window.contextPath + "/rest/topics/" + topicId + "/articles",
            {
                params: {
                    first, max
                }
            }))
    }
}

export const articleService = new ArticleService()
